var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7273 33.7202H26.8257V15.7202H32.7273M32.7273 45.7202H26.8257V39.7202H32.7273M29.7765 0.720215C25.9014 0.720215 22.0643 1.49619 18.4842 3.00383C14.9041 4.51147 11.6511 6.72125 8.91106 9.50701C3.3772 15.1331 0.268311 22.7637 0.268311 30.7202C0.268311 38.6767 3.3772 46.3073 8.91106 51.9334C11.6511 54.7192 14.9041 56.929 18.4842 58.4366C22.0643 59.9442 25.9014 60.7202 29.7765 60.7202C37.6026 60.7202 45.1081 57.5595 50.6419 51.9334C56.1758 46.3073 59.2847 38.6767 59.2847 30.7202C59.2847 26.7806 58.5215 22.8795 57.0385 19.2397C55.5556 15.5999 53.382 12.2928 50.6419 9.50701C47.9019 6.72125 44.6489 4.51147 41.0688 3.00383C37.4887 1.49619 33.6516 0.720215 29.7765 0.720215Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorInfo);
export default __webpack_public_path__ + "static/media/VectorInfo.a8c0ef0359991fd5f126e8393a4bbc05.svg";
export { ForwardRef as ReactComponent };